import React from 'react'
import './Footer.css'
import {SiGmail} from 'react-icons/si'
import {MdCall} from 'react-icons/md'
// import {BsLinkedin,BsGithub} from 'react-icons/bs'
export default function Footer() {
  return (
    <div className=' footer mb-0' style={{height:"4rem"}}>
      
      <div className='foooter_id'> <SiGmail ></SiGmail> qazizohaibali3@gmail.com </div> 

      <div className='foooter_id'><MdCall ></MdCall> +92 3473799289</div>
      {/* <div className="footer_icons">
        <a className='footer_linkedin' href="/"><BsLinkedin></BsLinkedin></a>
        <a className='footer_github' href="/"><BsGithub></BsGithub></a>
      
      </div> */}
    </div>
  )
}
